export default "__VITE_ASSET__BMrDPqtZ__"